import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=1b32502d&lang=pug&"
import script from "./switcher.vue?vue&type=script&lang=js&"
export * from "./switcher.vue?vue&type=script&lang=js&"
import style0 from "./switcher.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports